import React from 'react';
import { Row, Col, ListGroupItem, Panel, Grid, ListGroup } from 'react-bootstrap';

import './styles.css';

export default props => {
  const { outboundData, inboundData } = props;
  return (
    <Grid>
      <Panel>
        <Panel.Body>
          <Row>
            <Col xs={12} md={12} className="text-center">
              <Panel className="outbound-panel" >
                <Row>
                  <Panel.Heading>
                    <h4>
                      <strong>Your Details: Outbound</strong>
                    </h4>
                  </Panel.Heading>
                </Row>
                <Row>
                  <ListGroup fill className="list">
                    <Col xs={12} md={6} style={{ padding: '0' }} className="list2">
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>First Name</Col>
                          <Col xs={6}>{outboundData.forename}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Last Name</Col>
                          <Col xs={6}>{outboundData.surname}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Email</Col>
                          <Col xs={6}>{outboundData.email}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Phone</Col>
                          <Col xs={6}>{outboundData.mobile}</Col>
                        </Row>
                      </ListGroupItem>
                    </Col>
                    <Col xs={12} md={6} style={{ padding: '0' }} className="list2">
                      {outboundData.fromAccommodation.show ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Name</Col>
                            <Col xs={6}>{outboundData.fromAccommodation.name}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {outboundData.fromAccommodation.show ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Address</Col>
                            <Col xs={6}>{outboundData.fromAccommodation.street}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {outboundData.toAccommodation.show ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Name</Col>
                            <Col xs={6}>{outboundData.toAccommodation.name}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {outboundData.toAccommodation.show ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Address</Col>
                            <Col xs={6}>{outboundData.toAccommodation.street}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {outboundData.shuttle.showTimes ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Bus Info</Col>
                            <Col xs={6}>{outboundData.shuttle.bus.description}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {/* {outboundData.shuttle.showTo ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Address</Col>
                            <Col xs={6}>{outboundData.shuttle.arrivalStop.description}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null}
                      {outboundData.shuttle.showFrom ? (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Accommodation Address</Col>
                            <Col xs={6}>{outboundData.shuttle.departureStop.description}</Col>
                          </Row>
                        </ListGroupItem>
                      ) : null} */}
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Special requirements</Col>
                          <Col xs={6}>{outboundData.notes}</Col>
                        </Row>
                      </ListGroupItem>
                      {/* <ListGroupItem className="blankrow">
                        <Row>
                          <Col xs={6}>&nbsp;</Col>
                          <Col xs={6} />
                        </Row>
                      </ListGroupItem> */}
                    </Col>
                  </ListGroup>
                </Row>
              </Panel>
              {inboundData ? (
                <Panel className="outbound-panel">
                  <Row>
                    <Panel.Heading>
                      <h4>
                        <strong>Your Details: Return</strong>
                      </h4>
                    </Panel.Heading>
                  </Row>
                  <Row>
                    <ListGroup fill  className="list">
                      <Col xs={12} md={6} style={{ padding: '0' }} className="list2">
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>First Name</Col>
                            <Col xs={6}>{inboundData.forename}</Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Last Name</Col>
                            <Col xs={6}>{inboundData.surname}</Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Email</Col>
                            <Col xs={6}>{inboundData.email}</Col>
                          </Row>
                        </ListGroupItem>
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Phone</Col>
                            <Col xs={6}>{inboundData.mobile}</Col>
                          </Row>
                        </ListGroupItem>
                      </Col>
                      <Col xs={12} md={6} style={{ padding: '0' }} className="list2">
                        {inboundData.toAccommodation.show ? (
                          <ListGroupItem>
                            <Row>
                              <Col xs={6}>Accommodation Name</Col>
                              <Col xs={6}>{inboundData.toAccommodation.name}</Col>
                            </Row>
                          </ListGroupItem>
                        ) : null}
                        {inboundData.toAccommodation.show ? (
                          <ListGroupItem>
                            <Row>
                              <Col xs={6}>Accommodation Address</Col>
                              <Col xs={6}>{inboundData.toAccommodation.street}</Col>
                            </Row>
                          </ListGroupItem>
                        ) : null}
                        {inboundData.fromAccommodation.show ? (
                          <ListGroupItem>
                            <Row>
                              <Col xs={6}>Accommodation Name</Col>
                              <Col xs={6}>{inboundData.fromAccommodation.name}</Col>
                            </Row>
                          </ListGroupItem>
                        ) : null}
                        {inboundData.fromAccommodation.show ? (
                          <ListGroupItem>
                            <Row>
                              <Col xs={6}>Accommodation Address</Col>
                              <Col xs={6}>{inboundData.fromAccommodation.street}</Col>
                            </Row>
                          </ListGroupItem>
                        ) : null}
                        {inboundData.shuttle.showTimes ? (
                          <ListGroupItem>
                            <Row>
                              <Col xs={6}>Bus Info</Col>
                              <Col xs={6}>{inboundData.shuttle.bus.description}</Col>
                            </Row>
                          </ListGroupItem>
                        ) : null}
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>Special requirements</Col>
                            <Col xs={6}>{inboundData.notes}</Col>
                          </Row>
                        </ListGroupItem>
                        {/* <ListGroupItem className="blankrow">
                          <Row>
                            <Col xs={6}>&nbsp;</Col>
                            <Col xs={6} />
                          </Row>
                        </ListGroupItem> */}
                      </Col>
                    </ListGroup>
                  </Row>
                </Panel>
              ) : null}
            </Col>
          </Row>
        </Panel.Body>
      </Panel>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/YourDetails/index.js